import {
    AfterContentInit,
    Component, DoCheck,
    EventEmitter,
    Input,
    IterableDiffers, KeyValueDiffers,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";
import * as _ from "lodash";
import {DataMappingHelpers} from "../../../../../../../../models/data-mapping-helpers";
import { BaseError } from "../../../../../../base-error";
import {ToastrService} from "ngx-toastr";
import {RightSideComponent} from "../right-side.component";

@Component({
    selector: "field-item-group",
    templateUrl: "./field-item-group.component.html",
})
export class FieldItemGroupComponent extends BaseError implements OnChanges, DoCheck, AfterContentInit {

    @Input() public parentFieldItem: any = {};
    @Input() public isRoot: boolean = false;
    @Input() public fieldItem: any;
    @Input() public hidden: boolean;
    @Input() public type: string;
    @Input() public isLtr: boolean;
    @Input() public dragSrc: any = { el: null };
    @Input() public lines: any[] = [];
    @Input() public hideFields: any;

    @Input() public fieldIndex: number;
    @Input() public rightPrefix: string;
    @Input() public filter: any;

    @Output("showHideField") public showHideField: EventEmitter<any> = new EventEmitter();
    @Output("deleteSelection") public deleteSelection: EventEmitter<any> = new EventEmitter();
    @Output("handleEndPointSelection") public handleEndPointSelection: EventEmitter<any> = new EventEmitter();
    @Output("handleStartPointSelection") public handleStartPointSelection: EventEmitter<any> = new EventEmitter();
    @Output("addDataTransformation") public addDataTransformation: EventEmitter<any> = new EventEmitter();
    @Output("toggleBlock") public toggleBlock: EventEmitter<any> = new EventEmitter();
    @Output("toggleGroupVisibility") public toggleGroupVisibility: EventEmitter<any> = new EventEmitter();
    @Output("changeGroupMetaAfterNgOnChange") public changeGroupMetaAfterNgOnChange: EventEmitter<any> = new EventEmitter();
    @Output("changeGroupMetaAfterLineChange") public changeGroupMetaAfterLineChange: EventEmitter<any> = new EventEmitter();

    public linesDiffer: any = {};
    public hideFieldsDiffer: any = {};

    public oldDragSrcEl: any;
    public oldFieldItem: any;
    public oldParentFieldItem: any;

    constructor(private iterableDiffers: IterableDiffers, public toastr: ToastrService, private keyValueDiffers: KeyValueDiffers) {
        super(toastr);
        this.linesDiffer = iterableDiffers.find(this.lines).create(null);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.hidden) {
            this.changeGroupMetaAfterNgOnChange.emit({
                isRoot: this.isRoot,
                fieldItem: this.fieldItem,
                parentFieldItem: this.parentFieldItem,
            });
        }
    }

    public ngDoCheck() {
        // check if hideFields changed
        // tu put back maybe
        // const changeshiding = !_.isEmpty(this.hideFieldsDiffer) && this.hideFieldsDiffer.diff(this.hideFields);
        // if (changeshiding) {
            // const changedKeys = [];
            // changeshiding.forEachChangedItem((change) => changedKeys.push(change.key));
            // if (changedKeys.some((key) => this.belongsToGroup(key))) {
                // this.changeGroupMetaAfterNgOnChange.emit({
                    // isRoot: this.isRoot,
                    // fieldItem: this.fieldItem,
                    // parentFieldItem: this.parentFieldItem,
                // });
            // }
        // }

        // check if any new lines present or existing ones deleted
        const changes = this.linesDiffer.diff(this.lines);
        if (changes) { this.changeGroupMetaAfterLineChange.emit(this.fieldItem); }

        // check if fieldItem has changed
        const fieldItemChanged = !(_.isEqual(
            _.omit(this.fieldItem, ["meta"]),
            _.omit(this.oldFieldItem, ["meta"]),
        ));
        if (fieldItemChanged) {
            this.oldFieldItem = _.clone(this.fieldItem);
            this.changeMetaAfterFieldChange();
        }

        // check if parentFieldItem has changed
        const parentFieldItemChanged = !(_.isEqual(
            _.omit(this.parentFieldItem, ["meta"]),
            _.omit(this.oldParentFieldItem, ["meta"]),
        ));
        if (parentFieldItemChanged) {
            this.oldParentFieldItem = _.clone(this.parentFieldItem);
            this.changeGroupMetaAfterNgOnChange.emit({
                isRoot: this.isRoot,
                fieldItem: this.fieldItem,
                parentFieldItem: this.parentFieldItem,
            });
        }
    }
    public ngAfterContentInit() {
        // this.hideFieldsDiffer = this.keyValueDiffers.find(this.hideFields).create();
        this.oldFieldItem = _.clone(this.fieldItem);
        this.oldParentFieldItem = _.clone(this.parentFieldItem);
        this.initStaticMeta();
    }

    public handleSelectSelection(item: any) {
        console.log(item);
        if (this.isLtr) { return this.handleEndPointSelection.emit({
            input: item.field, selector: DataMappingHelpers.getSanitizeID(item.field.id || item.field.fieldKey), type: "input"});
        }
        return this.handleStartPointSelection.emit(item.field);
    }

    public changeMetaAfterFieldChange() {
        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.groupInnerRowClasses) { this.fieldItem.meta.groupInnerRowClasses = {}; }
        this.fieldItem.meta.groupInnerRowClasses.o = this.fieldItem.isopen;
    }

    private stripHtml(value: string): string {
        if (!value) { return value; }
        return value.replace(/<[^>]*>/g, "");
    }

    public initStaticMeta() {
        const customClass = RightSideComponent.customClassForGroupInnerRow(this.fieldItem, this.type);
        if (!this.fieldItem.meta) { this.fieldItem.meta = {}; }
        if (!this.fieldItem.meta.texts) { this.fieldItem.meta.texts = {}; }
        if (!this.fieldItem.meta.groupInnerRowClasses) { this.fieldItem.meta.groupInnerRowClasses = {}; }
        const name = this.stripHtml(this.fieldItem.name);
        const workingLabel = this.stripHtml(this.fieldItem.workingLabel);
        this.fieldItem.meta.texts.name = (workingLabel && workingLabel.length) ? `<span class="working-text">${workingLabel}<span class="working-text-tooltip">${DataMappingHelpers.formatName(name)}</span></span>` : DataMappingHelpers.formatName(name);
        this.fieldItem.meta.groupInnerRowClasses[customClass] = true;
        this.fieldItem.meta.groupInnerRowClasses.o = this.fieldItem.isopen;
        this.fieldItem.meta.groupInnerRowClasses["inputs-block-header-i"] = this.type === "input";
        this.fieldItem.meta.groupInnerRowClasses["inputs-block-header-o"] = this.type !== "input";
        this.fieldItem.meta.groupType = DataMappingHelpers.getFieldType(this.fieldItem.name, this.fieldItem.fieldId, this.fieldItem.type);
        this.fieldItem.meta.groupTypeClass = (this.fieldItem.meta.groupType || (this.fieldItem.type === "block" || this.fieldItem.type === "panel" || this.fieldItem.type === "editgrid" || this.fieldItem.type === "datagrid" || this.fieldItem.type === "container" || this.fieldItem.type === "tabs" || this.fieldItem.type === "select")) ? DataMappingHelpers.getFieldTypeClass(this.fieldItem.meta.groupType || this.fieldItem.type) : null;
    }

    private belongsToGroup(name, fieldItem = this.fieldItem): boolean {
        if (fieldItem.isgroup) {
            return fieldItem.items.some((item) => {
                return this.belongsToGroup(name, item);
            });
        }
        return fieldItem.field.name === name;
    }

    public getSanitizeID(type, prefix = ""): string {
        return DataMappingHelpers.getSanitizeID(type, prefix);
    }

    public filterGroupsFromItems() {
        return this.fieldItem.items.filter((item) => item.isgroup && item.items?.length);
    }

    public filterItemsFromItems() {
        return this.fieldItem.items.filter((item) => !item.isgroup);
    }
}
